import React from 'react';
import { BarChartData } from '../../types';
import './BarChart.css';

interface BarChartProps {
  data: BarChartData[];
  title?: string;
  maxValue?: number;
}

export const BarChart: React.FC<BarChartProps> = ({ data, title, maxValue }) => {
  const max = maxValue || Math.max(...data.map(d => d.value), 1);

  return (
    <div className="admin-bar-chart">
      {title && <h3 className="admin-bar-chart__title">{title}</h3>}
      <div className="admin-bar-chart__bars">
        {data.map((item, index) => {
          const widthPercent = (item.value / max) * 100;
          return (
            <div key={index} className="admin-bar-chart__row">
              <span className="admin-bar-chart__label" title={item.label}>
                {item.label}
              </span>
              <div className="admin-bar-chart__bar-container">
                <div
                  className="admin-bar-chart__bar"
                  style={{
                    width: `${widthPercent}%`,
                    backgroundColor: item.color || '#4285F4',
                    animationDelay: `${index * 60}ms`,
                  }}
                />
              </div>
              <span className="admin-bar-chart__value">{item.value}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
